export function setDesc(desc) {
	document.desc = `${desc}`;
}